import { DateInput, TextInput } from '@core/components/Inputs';
import CurrencyTextField from '@core/components/Inputs/CurrencyTextField';
import { FormControlLabel, Grid, Switch, Tooltip } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React, { useContext } from 'react';
import { ContaContext } from '../../../ContaContext';

const EditarContaCaixinhaForm = () => {
  const formik = useFormikContext();
  const [contaAtual] = useContext(ContaContext).contaAtual;
  
  const { errors, touched, submitCount } = formik;

  const _errors = {
    descricao: (submitCount || touched?.descricao) && errors?.descricao,
    contaCaixinha: {
      saldoInicial: (submitCount || touched?.contaCaixinha?.saldoInicial) && errors?.contaCaixinha?.saldoInicial,
      dataSaldo: (submitCount || touched?.contaCaixinha?.dataSaldo) && errors?.contaCaixinha?.dataSaldo,
      dataEncerramento:
        (submitCount || touched?.contaCaixinha?.dataEncerramento) && errors?.contaCaixinha?.dataEncerramento,
    },
  };

  return (
    <Grid container spacing={3} className="mt-56">
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="descricao"
          name="descricao"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.descricao}
          touched={formik.touched.descricao}
          error={_errors.descricao}
          required
          fullWidth
          autoFocus
          maxLength={30}
          label="Descrição"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Tooltip
          placement="top-start"
          title="Saldo que o sistema irá considerar para cálculos automáticos conforme movimentações posteriores à data informada"
        >
          <div>
            <CurrencyTextField
              id="contaCaixinha.saldoInicial"
              name="contaCaixinha.saldoInicial"
              label="Saldo inicial (R$)*"
              variant="outlined"
              fullWidth
              value={formik.values?.contaCaixinha?.saldoInicial}
              outputFormat="number"
              decimalCharacter=","
              digitGroupSeparator="."
              classes={{}}
              maximumValue="999999999"
              decimalPlaces={2}
              decimalPlacesShownOnBlur={2}
              decimalPlacesShownOnFocus={2}
              error={!!_errors.contaCaixinha.saldoInicial}
              helperText={_errors.contaCaixinha.saldoInicial || ''}
              onChange={(e, value) => {
                formik.setFieldValue('contaCaixinha.saldoInicial', value);
              }}
              onBlur={formik.handleBlur}
            />
          </div>
        </Tooltip>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <DateInput
          fullWidth
          disableFuture
          id="contaCaixinha.dataSaldo"
          name="contaCaixinha.dataSaldo"
          label="Data do saldo*"
          value={formik.values?.contaCaixinha?.dataSaldo}
          error={!!_errors.contaCaixinha.dataSaldo}
          helperText={_errors.contaCaixinha.dataSaldo || ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </Grid>

      {contaAtual?.id && (
        <Grid item xs={6} sm={4} md={3} lg={3} xl={3}>
          <FormControlLabel
            control={
              <Switch
                id="contaCaixinha.encerrarConta"
                name="contaCaixinha.encerrarConta"
                value={formik.values?.contaCaixinha?.encerrarConta}
                checked={formik.values?.contaCaixinha?.encerrarConta}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                color="primary"
              />
            }
            label="Encerrar conta"
          />
        </Grid>
      )}
      {formik.values?.contaCaixinha?.encerrarConta && (
        <Grid item xs={6} sm={4} md={3} lg={3} xl={3}>
          <DateInput
            fullWidth
            disableFuture
            id="contaCaixinha.dataEncerramento"
            name="contaCaixinha.dataEncerramento"
            label="Data do encerramento*"
            value={formik.values?.contaCaixinha?.dataEncerramento}
            error={!!_errors.contaCaixinha.dataEncerramento}
            helperText={_errors.contaCaixinha.dataEncerramento || ''}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default EditarContaCaixinhaForm;
